document.addEventListener('DOMContentLoaded', function() {
  
  // Initialise the Watch Sliders
  const watchSliderCarousels = document.querySelectorAll('.watchSlider__Carousel');

  watchSliderCarousels.forEach(carousel => {
    $(carousel).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      prevArrow: $(carousel).parent().find('.watchSlider__Prev'),
      nextArrow: $(carousel).parent().find('.watchSlider__Next')
    });

    // Handle setting the background gradient colours
    function setBackgroundGradient() {
      const parent = $(carousel).parent()[0];
      let primaryColor = $(carousel).find('.watchSlider__Slide:first-child').data('primary-color');
      let secondaryColor = $(carousel).find('.watchSlider__Slide:first-child').data('secondary-color');

      if (parent) {
        parent.style.setProperty('--primary-color', primaryColor);
        parent.style.setProperty('--secondary-color', secondaryColor);
      }

      // Handle updating the background gradient colours when the slider changes
      $(carousel).on('afterChange', function() {
        const currentSlide = $(carousel).find('.slick-current .watchSlider__Slide');

        primaryColor = currentSlide.data('primary-color');
        secondaryColor = currentSlide.data('secondary-color');

        if (parent) {
          parent.style.setProperty('--primary-color', primaryColor);
          parent.style.setProperty('--secondary-color', secondaryColor);
        }
      });
    }

    setBackgroundGradient();
  });


  const watchUpsellCarousels = document.querySelectorAll('.buyingPanel__UpsellsList');

  watchUpsellCarousels.forEach(carousel => {
    $(carousel).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      prevArrow: $(carousel).parent().find('.buyingPanel__UpsellsControl--left'),
      nextArrow: $(carousel).parent().find('.buyingPanel__UpsellsControl--right')
    });
  });

    // Initialise generic sliders
  const sliders = document.querySelectorAll('.slider');

  sliders.forEach(slider => {
    const wrapper = slider.closest('.slider__Wrapper');

    const desktopSlides = parseFloat(wrapper.dataset.desktopSlides) || 3.1;
    const tabletSlides  = parseFloat(wrapper.dataset.tabletSlides)  || 2.1;
    const mobileSlides  = parseFloat(wrapper.dataset.mobileSlides)  || 1.1;

    $(slider).slick({
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      prevArrow: wrapper.querySelector('.slider__Prev'),
      nextArrow: wrapper.querySelector('.slider__Next'),
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: mobileSlides
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: tabletSlides
          }
        },
        {
          breakpoint: 9999,
          settings: {
            slidesToShow: desktopSlides
          }
        }
      ]
    });
  });
});